/**
 * Footer Component
 * Site footer with links and legal information
 */

export function renderFooter() {
  const currentYear = new Date().getFullYear();

  return `
    <footer class="footer">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-brand">
            <div class="footer-logo">
              <svg width="32" height="32" viewBox="0 0 100 100" fill="none">
                <defs>
                  <linearGradient id="footerLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style="stop-color:#1a5276"/>
                    <stop offset="100%" style="stop-color:#0f3049"/>
                  </linearGradient>
                </defs>
                <rect width="100" height="100" rx="16" fill="url(#footerLogoGrad)"/>
                <path d="M50 20L20 45V80H40V60H60V80H80V45L50 20Z" fill="white"/>
              </svg>
              <span>Jóvenes Independientes</span>
            </div>
            <p class="footer-description">
              Tu guía completa para el proceso de compra de vivienda en España. 
              Herramientas, calculadoras y toda la información que necesitas.
            </p>
            <div class="footer-social">
              <a href="#" aria-label="Twitter">
                <i data-feather="twitter"></i>
              </a>
              <a href="#" aria-label="LinkedIn">
                <i data-feather="linkedin"></i>
              </a>
              <a href="#" aria-label="Instagram">
                <i data-feather="instagram"></i>
              </a>
            </div>
          </div>
          
          <div class="footer-column">
            <h4>Producto</h4>
            <ul class="footer-links">
              <li><a href="/guia" data-link>Guía Hipotecaria</a></li>
              <li><a href="/gastos" data-link>Calculadora Gastos</a></li>
              <li><a href="/ahorro" data-link>Plan de Ahorro</a></li>
              <li><a href="/ayudas" data-link>Ayudas Públicas</a></li>
              <li><a href="/plantillas" data-link>📊 Plantillas Excel</a></li>
            </ul>
          </div>
          
          <div class="footer-column">
            <h4>Recursos</h4>
            <ul class="footer-links">
              <li><a href="#">Blog</a></li>
              <li><a href="#">Glosario</a></li>
              <li><a href="#">FAQ</a></li>
              <li><a href="#">Contacto</a></li>
            </ul>
          </div>
          
          <div class="footer-column">
            <h4>Legal</h4>
            <ul class="footer-links">
              <li><a href="#" id="legalNoticeLink">Aviso Legal</a></li>
              <li><a href="/privacidad" data-link>Política de Privacidad</a></li>
              <li><a href="/cookies" data-link>Política de Cookies</a></li>
              <li><a href="/terminos" data-link>Términos y Condiciones</a></li>
            </ul>
          </div>
        </div>
        
        <div class="footer-bottom">
          <p>© ${currentYear} Jóvenes Independientes. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
    
    <!-- Legal Disclaimer Modal -->
    <div class="modal-overlay" id="legalModal">
      <div class="modal">
        <div class="modal-header">
          <h3>Aviso Legal</h3>
          <button class="modal-close" id="closeLegalModal">
            <i data-feather="x"></i>
          </button>
        </div>
        <div class="modal-body" style="color: var(--gray-600); line-height: 1.8;">
          <h4 style="color: var(--gray-900); margin-bottom: 12px;">⚠️ Información importante</h4>
          <p style="margin-bottom: 16px;">
            <strong>Este servicio NO constituye asesoramiento financiero, legal ni inmobiliario.</strong>
          </p>
          <p style="margin-bottom: 16px;">
            La información proporcionada en Jóvenes Independientes tiene carácter meramente informativo y 
            orientativo. Las calculadoras y herramientas ofrecen estimaciones basadas en los datos 
            introducidos y no deben considerarse como ofertas vinculantes ni compromisos contractuales.
          </p>
          <p style="margin-bottom: 16px;">
            <strong>Recomendamos encarecidamente:</strong>
          </p>
          <ul style="margin-left: 20px; margin-bottom: 16px;">
            <li>Consultar con un asesor financiero cualificado antes de tomar decisiones de inversión</li>
            <li>Verificar la información sobre ayudas públicas directamente con los organismos oficiales</li>
            <li>Solicitar ofertas vinculantes a las entidades bancarias</li>
            <li>Consultar con un notario o abogado para cuestiones legales</li>
          </ul>
          <p style="margin-bottom: 16px;">
            Los datos sobre tipos de interés, ayudas y normativa pueden variar y están sujetos a 
            cambios legislativos. Jóvenes Independientes no se responsabiliza de las decisiones tomadas 
            basándose en la información proporcionada.
          </p>
          <p>
            <strong>Protección de datos:</strong> Cumplimos con el Reglamento General de Protección 
            de Datos (RGPD) y la LOPD-GDD. Sus datos personales se tratan con la máxima confidencialidad.
          </p>
        </div>
      </div>
    </div>
  `;
}

// Initialize footer interactions
document.addEventListener('routeChanged', () => {
  initFooterInteractions();
});

function initFooterInteractions() {
  const legalModal = document.getElementById('legalModal');
  const closeLegalModal = document.getElementById('closeLegalModal');
  const legalNoticeLink = document.getElementById('legalNoticeLink');

  if (legalNoticeLink && legalModal) {
    legalNoticeLink.addEventListener('click', (e) => {
      e.preventDefault();
      legalModal.classList.add('active');
    });
  }

  if (closeLegalModal && legalModal) {
    closeLegalModal.addEventListener('click', () => {
      legalModal.classList.remove('active');
    });

    legalModal.addEventListener('click', (e) => {
      if (e.target === legalModal) {
        legalModal.classList.remove('active');
      }
    });
  }
}

setTimeout(initFooterInteractions, 100);
